import { render, staticRenderFns } from "./SiteContentPageWrapper.vue?vue&type=template&id=4fc1ea86&scoped=true&"
import script from "./SiteContentPageWrapper.vue?vue&type=script&lang=js&"
export * from "./SiteContentPageWrapper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fc1ea86",
  null
  
)

export default component.exports